import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import c from 'classnames';
import { Menu } from '@uncinc/react-drupal-core';
import config from 'react-global-configuration';
import { showNavMenu, hideNavMenu } from '../../../actions/UI';

import {
  Container,
  Hamburger,
  Button,
  Logo,
  CoreLink,
} from '../../../components';

import {
  NavigationSecondaryMenu,
  NavigationMainMenuMobile,
  NavigationMainMenuDesktop,
} from '../..';

import { MENU, MENU_KP, SCREEN_NORMAL, APP_OPTIONS } from '../../../config/constants';

import AnimationWrapper from '../AnimationWrapper';
import './style.scss';

class NavigationFull extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      searchVisible: false,
      reachedTop: true,
      scrolledPastNavHeight: true,
      menuItemsToggled: [],
      mainMenuDepth: 0,
      pathArray: [],
      windowWidth: window.innerWidth,
    };
  }

  onUpdateAnimationWrapper = (isVisible, hasReachedTop, scrolledPastNavHeight) => {
    const shouldUpdate = (
      this.state.visible !== isVisible
      || this.state.reachedTop !== hasReachedTop
      || this.state.scrolledPastNavHeight !== scrolledPastNavHeight
    );

    if (shouldUpdate) {
      this.setState({
        scrolledPastNavHeight,
        visible: isVisible,
        reachedTop: hasReachedTop,
      });
    }
  };

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth });
  };

  setMainMenuDepth = (depth) => {
    this.setState({
      mainMenuDepth: depth,
    });
  };

  setPathArray = (value) => {
    this.setState({ pathArray: value });
  };

  onHamburgerClick = () => {
    if (this.props.showNavMenu) {
      this.setState({ pathArray: [] });
      this.props.dispatch(hideNavMenu());
    } else {
      this.props.dispatch(showNavMenu());
    }
  };

  toggleNavigationItem = (entityId) => {
    const { menuItemsToggled } = this.state;

    this.setState((prevState) => ({
      menuItemsToggled: {
        ...menuItemsToggled,
        [entityId]: !prevState.menuItemsToggled[entityId],
      },
    }));
  };


  setInputValue = (e) => {
    this.setState({ searchInput: e.target.value });
  };

  submitSearch = () => {
    const { history, dispatch } = this.props;
    const { searchInput } = this.state;
    dispatch(hideNavMenu());

    window.scrollTo(0, 0);

    this.setState((prevState) => ({
      searchVisible: false,
    }));

    history.push({
      pathname: '/zoeken',
      search: `?${encodeURIComponent(`${APP_OPTIONS.parameters.searchkitIndexAllContentSearch}[query]`)}=${searchInput || ''}`,
    });
  };

  catchEnter = (e) => {
    if (e.key === 'Enter') {
      this.submitSearch();
    }
  };

  componentWillUnmount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    // sticky navbar
    document.addEventListener('DOMContentLoaded', () => {
      window.onscroll = function () { stickyHandler(); };
      const navbar = document.querySelector('.Navigation');
      const wrapper = document.querySelector('.AnimationWrapper');
      const sticky = navbar.offsetTop;
      /**
       *
       */
      function stickyHandler() {
        if (window.pageYOffset >= sticky + 32) {
          wrapper.classList.add('Navigation__sticky');
        } else {
          wrapper.classList.remove('Navigation__sticky');
        }
      }
    });
  }

  render() {
    const { reachedTop, visible, scrolledPastNavHeight, menuItemsToggled, searchVisible, mainMenuDepth, searchInput, pathArray, windowWidth } = this.state;

    const { path } = this.props;
    const classes = c('Navigation', {
      's-reached-top': reachedTop,
      's-visible': visible,
      's-scrolled-past-nav-height': scrolledPastNavHeight,
    });

    const searchClasses = c('Navigation__search', {
      'Navigation__search--active': searchVisible,
    });

    const magicLineRef = React.createRef();

    const searchInputRef = React.createRef();

    const toggleSearch = () => {
      searchInputRef.current.focus();

      this.setState((prevState) => ({
        searchVisible: !prevState.searchVisible,
      }));
    };

    const searchButtonClasses = c('Navigation__buttons--secondary', {
      'Navigation__buttons--secondary--search-visible': searchVisible,
    });

    const isTablet = windowWidth < SCREEN_NORMAL;

    return (
      <AnimationWrapper onUpdate={this.onUpdateAnimationWrapper} hasBackground>
        <div ref={magicLineRef} className="NavigationMainMenuDesktop__magic-line" />
        {mainMenuDepth < 1 && (
          <Container>
            <NavigationSecondaryMenu />
          </Container>
        )}
        <Container className={classes} ref={(node) => this.menuNode = node}>
          <div className="Navigation__topBarBg" />
          <Logo />
          <div className="menu-wrapper">
            <div className="Navigation__menus">
              <div className={`Navigation__menus__wrapper ${isTablet ? 'container' : ''}`}>
                <Menu id={config.get('CURRENT_DOMAIN') === 'kp' ? MENU_KP : MENU}>
                  {(items) => {
                    return (
                      <>
                        <NavigationMainMenuMobile
                          path={path}
                          items={items}
                          toggleNavigationItem={this.toggleNavigationItem}
                          setInputValue={this.setInputValue}
                          catchEnter={this.catchEnter}
                          submitSearch={this.submitSearch}
                          setMainMenuDepth={this.setMainMenuDepth}
                          searchValue={searchInput}
                          pathArray={pathArray}
                          setPathArray={this.setPathArray}
                        />
                        <NavigationMainMenuDesktop
                          path={path}
                          items={items}
                          toggleNavigationItem={this.toggleNavigationItem}
                          menuItemsToggled={menuItemsToggled}
                          magicLineRef={magicLineRef}
                        />
                      </>

                    );
                  }}
                </Menu>
                <div className="Navigation__mobileSubmenu">
                  {config.get('CURRENT_DOMAIN') !== 'kp' && (
                    <Menu id="support-us">
                      {(items) => {
                        return (
                          <div className="">
                            {items.map((item) => {
                              const href = item.getIn(['link', 'url'], '');
                              const title = item.getIn(['link', 'title'], 'Untitled');
                              return (
                                <>
                                  {title}
                                  <CoreLink
                                    to={href}
                                    className="">
                                    <div className="Navigation__mobile__donate icon-before icon-donate icon-variant-1 mobile-donate" />
                                  </CoreLink>
                                </>
                              );
                            })}
                          </div>
                        );
                      }}
                    </Menu>
                  )}
                  <NavigationSecondaryMenu />
                </div>
              </div>
              {config.get('CURRENT_DOMAIN') !== 'kp' && (
                <div className="Navigation__buttons">
                  <Menu id="support-us">
                    {(items) => {
                      return (
                        <div className="NavigationSecondaryMenu__items row">
                          {items.map((item) => {
                            const href = item.getIn(['link', 'url'], '');
                            const title = item.getIn(['link', 'title'], 'Untitled');
                            return (
                              <Button
                                className="Navigation__buttons--secondary Button--purple icon-after icon-heart icon-variant-4"
                                key={`menu--main--menu-item-${title}:${href}`}
                                href={href}
                                primary
                              >
                                {title}
                              </Button>
                            );

                          })}
                        </div>
                      );
                    }}
                  </Menu>
                  <Button href="#" onClick={() => { toggleSearch(); }} className={searchButtonClasses} tertiary>
                    <div className="icon icon-search icon-variant-2" />
                  </Button>
                </div>
              )}
            </div>
          </div>
          <div className="Navigation__mobile">
            {config.get('CURRENT_DOMAIN') !== 'kp' && (
              <Menu id="support-us">
                {(items) => {
                  return (
                    <div className="">
                      {items.map((item) => {
                        const href = item.getIn(['link', 'url'], '');
                        const title = item.getIn(['link', 'title'], 'Untitled');
                        return (
                          <>
                            <CoreLink
                              to={href}
                              className="">
                              <div className="Navigation__mobile__donate icon-before icon-donate icon-variant-1 mobile-donate" />
                            </CoreLink>
                            <Button
                              className="Navigation__buttons--secondary Button--purple icon-after icon-heart icon-variant-4 tablet-donate"
                              href={href}
                              primary
                            >
                              {title}
                            </Button>
                          </>
                        );
                      })}
                    </div>
                  );
                }}
              </Menu>
            )}
            <Button onClick={() => { toggleSearch(); }} className="Navigation__buttons--secondary tablet-search-btn" tertiary>
              <div className="icon icon-search icon-variant-2" />
            </Button>
            <Hamburger handleClick={this.onHamburgerClick} />
          </div>
        </Container>
        <div className={searchClasses}>
          <div className="container Navigation__search__inner Container">
            <input
              onChange={(e) => { this.setInputValue(e); }}
              onKeyDown={(e) => { this.catchEnter(e); }}
              ref={searchInputRef}
              className="Navigation__search__input"
              type="text"
              placeholder="Zoeken..." />
            <div
              onClick={this.submitSearch}
              className="Navigation__search__submit icon-before icon-search icon-variant-3" />
          </div>
        </div>
      </AnimationWrapper>
    );
  }
}

/**
 * @example
 * @param state
 * @param ownProps
 */
function mapStateToProps(state, ownProps) {

  return {
    path: state.getIn(['router', 'location', 'pathname']),
    showNavMenu: state.getIn(['uiInternal', 'showNavMenu']),
  };
}

export default withRouter(connect(mapStateToProps)(NavigationFull));
